import React, { useEffect, useState } from "react";
import { ThreeCircles } from 'react-loader-spinner';
import useHttp from "../../../../hook/use-http";
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates_kratos';
import styles from '../ChargingPageCustom_Kratos.module.css'

const TOP_KPIS_FIRST_PAGE = {
  median_delta_soc: 0,
  median_kwhCharged: 0,
  median_B_Max_Cell_Temp: 0,
  median_soc_start: 0,
  median_A_Max_Cell_Temp: 0,
  median_NoOfInterrupt: 0,
  median_gunAfterfullchargeInMin: 0,
  median_InterruptDurationInMin: 0,
  median_roc: 0,
  median_chargeDurationInMin: 0,
  median_C_Max_Cell_Temp: 0,
  median_gunDurationInMin: 0,
  median_D_Max_Cell_Temp: 0,
  median_soc_end: 0,
  median_avgChargingCurrent: 0,
};

export default function HighlightsKpis_Kratos({ gloablfilter }) {

  const [doc_cnt, setdoc_cnt] = useState(0)
  const [Daily_Charging_kWh_vehicle, setDaily_Charging_kWh_vehicle] = useState(0)
  const [Daily_Charging_Duration_vehicle, setDaily_Charging_Duration_vehicle] = useState(0)
  const [median_delta_soc, setmedian_delta_soc] = useState(0)
  const [median_kwhCharged, setmedian_kwhCharged] = useState(0)
  const [median_B_Max_Cell_Temp, setmedian_B_Max_Cell_Temp] = useState(0)
  const [median_soc_start, setmedian_soc_start] = useState(0)
  const [median_A_Max_Cell_Temp, setmedian_A_Max_Cell_Temp] = useState(0)
  const [median_NoOfInterrupt, setmedian_NoOfInterrupt] = useState(0)
  const [median_gunAfterfullchargeInMin, setmedian_gunAfterfullchargeInMin] = useState(0)
  const [median_InterruptDurationInMin, setmedian_InterruptDurationInMin] = useState(0)
  const [median_roc, setmedian_roc] = useState(0)
  const [median_chargeDurationInMin, setmedian_chargeDurationInMin] = useState(0)
  const [median_C_Max_Cell_Temp, setmedian_C_Max_Cell_Temp] = useState(0)
  const [median_gunDurationInMin, setmedian_gunDurationInMin] = useState(0)
  const [median_D_Max_Cell_Temp, setmedian_D_Max_Cell_Temp] = useState(0)
  const [median_soc_end, setmedian_soc_end] = useState(0)
  const [median_avgChargingCurrent, setmedian_avgChargingCurrent] = useState(0)

  const { isLoading, error, sendReq: fetchData } = useHttp();
  function median(numbers) {
    const sorted = Array.from(numbers).sort((a, b) => a - b);
    const middle = Math.floor(sorted.length / 2);

    if (sorted.length % 2 === 0) {
      if ((((sorted[middle - 1] + sorted[middle]) / 2).toFixed(2)) !== "NaN")
        return ((sorted[middle - 1] + sorted[middle]) / 2);
      else
        return 0
    }
    if ((sorted[middle].toFixed(2)) !== "NaN")
      return sorted[middle]
    else
      return 0
  }
  const appyData = (data) => {
    const res_result = data;

    let median_delta_soc = []
    let median_kwhCharged = []
    let median_B_Max_Cell_Temp = []
    let median_soc_start = []
    let median_A_Max_Cell_Temp = []
    let median_NoOfInterrupt = []
    let median_gunAfterfullchargeInMin = []
    let median_InterruptDurationInMin = []
    let median_roc = []
    let median_chargeDurationInMin = []
    let median_C_Max_Cell_Temp = []
    let median_gunDurationInMin = []
    let median_D_Max_Cell_Temp = []
    let median_soc_end = []
    let median_avgChargingCurrent = []

    if (res_result.length !== 0) {
      let temp_result = res_result;

      data.forEach((obj1, index) => {
        if (obj1.median_delta_soc.values["50.0"] != null)
          setmedian_delta_soc(obj1.median_delta_soc.values["50.0"])
        else
          setmedian_delta_soc(0)

        if (obj1.median_kwhCharged.values["50.0"] != null)
          setmedian_kwhCharged(obj1.median_kwhCharged.values["50.0"])
        else
          setmedian_kwhCharged(0)

        if (obj1.median_B_Max_Cell_Temp.value != null)
          setmedian_B_Max_Cell_Temp(obj1.median_B_Max_Cell_Temp.value)
        else
          setmedian_B_Max_Cell_Temp(0)

        if (obj1.median_soc_start.values["50.0"] != null)
          setmedian_soc_start(obj1.median_soc_start.values["50.0"])
        else
          setmedian_soc_start(0)

        if (obj1.median_A_Max_Cell_Temp.value != null)
          setmedian_A_Max_Cell_Temp(obj1.median_A_Max_Cell_Temp.value)
        else
          setmedian_A_Max_Cell_Temp(0)

        if (obj1.median_NoOfInterrupt.values["50.0"] != null)
          setmedian_NoOfInterrupt(obj1.median_NoOfInterrupt.values["50.0"])
        else
          setmedian_NoOfInterrupt(0)

        if (obj1.median_gunAfterfullchargeInMin.values["50.0"] != null)
          setmedian_gunAfterfullchargeInMin(obj1.median_gunAfterfullchargeInMin.values["50.0"])
        else
          setmedian_gunAfterfullchargeInMin(0)

        if (obj1.median_InterruptDurationInMin.values["50.0"] != null)
          setmedian_InterruptDurationInMin(obj1.median_InterruptDurationInMin.values["50.0"])
        else
          setmedian_InterruptDurationInMin(0)

        if (obj1.median_roc.values["50.0"] != null)
          setmedian_roc(obj1.median_roc.values["50.0"])
        else
          setmedian_roc(0)

        if (obj1.median_chargeDurationInMin.values["50.0"] != null)
          setmedian_chargeDurationInMin(obj1.median_chargeDurationInMin.values["50.0"])
        else
          setmedian_chargeDurationInMin(0)

        if (obj1.median_C_Max_Cell_Temp.value != null)
          setmedian_C_Max_Cell_Temp(obj1.median_C_Max_Cell_Temp.value)
        else
          setmedian_C_Max_Cell_Temp(0)

        if (obj1.median_gunDurationInMin.values["50.0"] != null)
          setmedian_gunDurationInMin(obj1.median_gunDurationInMin.values["50.0"])
        else
          setmedian_gunDurationInMin(0)

        if (obj1.median_D_Max_Cell_Temp.value != null)
          setmedian_D_Max_Cell_Temp(obj1.median_D_Max_Cell_Temp.value)
        else
          setmedian_D_Max_Cell_Temp(0)

        if (obj1.median_soc_end.values["50.0"] != null)
          setmedian_soc_end(obj1.median_soc_end.values["50.0"])
        else
          setmedian_soc_end(0)

        if (obj1.median_avgChargingCurrent.values["50.0"] != null)
          setmedian_avgChargingCurrent(obj1.median_avgChargingCurrent.values["50.0"])
        else
          setmedian_avgChargingCurrent(0)
      })

      setmedian_delta_soc(median_delta_soc.toFixed(0))
      // median(median_delta_soc)
      setmedian_kwhCharged(median_kwhCharged.toFixed(0))
      // median(median_kwhCharged)
      setmedian_B_Max_Cell_Temp(median_B_Max_Cell_Temp)
      // median(median_B_Max_Cell_Temp)
      setmedian_soc_start(median_soc_start)
      // median(median_soc_start)
      setmedian_A_Max_Cell_Temp(median_A_Max_Cell_Temp)
      // median(median_A_Max_Cell_Temp)
      setmedian_NoOfInterrupt(median_NoOfInterrupt)
      // median(median_NoOfInterrupt)
      setmedian_gunAfterfullchargeInMin(median_gunAfterfullchargeInMin)
      // median(median_gunAfterfullchargeInMin)
      setmedian_InterruptDurationInMin(median_InterruptDurationInMin)
      // median(median_InterruptDurationInMin)
      setmedian_roc(median_roc)
      // median(median_roc)
      setmedian_chargeDurationInMin(median_chargeDurationInMin)
      // median(median_chargeDurationInMin)
      setmedian_C_Max_Cell_Temp(median_C_Max_Cell_Temp)
      // median(median_C_Max_Cell_Temp)
      setmedian_gunDurationInMin(median_gunDurationInMin)
      // median(median_gunDurationInMin)
      setmedian_D_Max_Cell_Temp(median_D_Max_Cell_Temp)
      // median(median_D_Max_Cell_Temp)
      setmedian_soc_end(median_soc_end)
      // median(median_soc_end)
      setmedian_avgChargingCurrent(median_avgChargingCurrent)
      // median(median_avgChargingCurrent)
    } else {
      setmedian_delta_soc(median_delta_soc.toFixed(0))
      // median(median_delta_soc)
      setmedian_kwhCharged(median_kwhCharged.toFixed(0))
      // median(median_kwhCharged)
      setmedian_B_Max_Cell_Temp(median_B_Max_Cell_Temp)
      // median(median_B_Max_Cell_Temp)
      setmedian_soc_start(median_soc_start)
      // median(median_soc_start)
      setmedian_A_Max_Cell_Temp(median_A_Max_Cell_Temp)
      // median(median_A_Max_Cell_Temp)
      setmedian_NoOfInterrupt(median_NoOfInterrupt)
      // median(median_NoOfInterrupt)
      setmedian_gunAfterfullchargeInMin(median_gunAfterfullchargeInMin)
      // median(median_gunAfterfullchargeInMin)
      setmedian_InterruptDurationInMin(median_InterruptDurationInMin)
      // median(median_InterruptDurationInMin)
      setmedian_roc(median_roc)
      // median(median_roc)
      setmedian_chargeDurationInMin(median_chargeDurationInMin)
      // median(median_chargeDurationInMin)
      setmedian_C_Max_Cell_Temp(median_C_Max_Cell_Temp)
      // median(median_C_Max_Cell_Temp)
      setmedian_gunDurationInMin(median_gunDurationInMin)
      // median(median_gunDurationInMin)
      setmedian_D_Max_Cell_Temp(median_D_Max_Cell_Temp)
      // median(median_D_Max_Cell_Temp)
      setmedian_soc_end(median_soc_end)
      // median(median_soc_end)
      setmedian_avgChargingCurrent(median_avgChargingCurrent)
      // median(median_avgChargingCurrent)
    }
  }

  const time_convert = (num) => {
    var hours = Math.floor(num / 60);
    var minutes = Math.floor(num % 60);
    var seconds = Math.round((num % 1) * 60); // Convert fractional part to seconds and round
    // Add leading zero if needed
    hours = (hours < 10) ? "0" + hours : hours;
    minutes = (minutes < 10) ? "0" + minutes : minutes;
    seconds = (seconds < 10) ? "0" + seconds : seconds;
    return hours + ":" + minutes + ":" + seconds;
  }

  const appyDataDaily = (data) => {
    const res_result = data;

    let doc_cnt = []
    let Daily_Charging_kWh_vehicle = []
    let Daily_Charging_Duration_vehicle = []


    if (res_result.length !== 0) {
      let temp_result = res_result;

      data.forEach((obj1, index) => {
        if (obj1.Daily_Charging_kWh_vehicle.value != null)
          Daily_Charging_kWh_vehicle.push(obj1.Daily_Charging_kWh_vehicle.value)
        if (obj1.Daily_Charging_Duration_vehicle.value != null)
          Daily_Charging_Duration_vehicle.push(obj1.Daily_Charging_Duration_vehicle.value)
        if (obj1.doc_count != null)
          doc_cnt.push(obj1.doc_count)
      })

      setdoc_cnt(median(doc_cnt))
      setDaily_Charging_kWh_vehicle(median(Daily_Charging_Duration_vehicle))
      setDaily_Charging_Duration_vehicle(median(Daily_Charging_kWh_vehicle))
    } else {
      setdoc_cnt(median(doc_cnt))
      setDaily_Charging_kWh_vehicle(median(Daily_Charging_Duration_vehicle))
      setDaily_Charging_Duration_vehicle(median(Daily_Charging_kWh_vehicle))
    }
  }

  useEffect(() => {
    fetchData({ url: API_URL_MAIN + "kratos_charge/hightlights", body: { filterdata: gloablfilter } }, appyData)
    fetchData({ url: API_URL_MAIN + "kratos_charge/hightlightsDaily", body: { filterdata: gloablfilter } }, appyDataDaily)
  }, [gloablfilter])

  const handleChageout = (event) => {
    ("#inlineRadioFast2").checked = true
  }
  const handlechange = (event) => {
    ("#inlineRadioSlow1").checked = true
  }

  let loader = (<div style={{ margin: "auto" }}><ThreeCircles
    height="50"
    width="40"
    wrapperStyle={{}}
    wrapperclassName=""
    visible={true}
    ariaLabel="three-circles-rotating"
    outerCircleColor="#3498db"
    innerCircleColor="#dec52d"
    middleCircleColor="#db213a"
  /></div>)
  return (
    <>
      <div className="col-lg-12 mb-3">
        <div className={`${styles.chargingChartbox_Kratos} ${styles.highlightBoxKpi_Kratos}`}>
          <div className={`v-title ${styles.chargingTitleBg_Kratos}`}>
            <div className="row p-2">
              <div className="col-lg-8 col-md-7 col-sm-9 col-9 text-start">
                <b>Highlights</b>
              </div>
              <div className="col-lg-4 col-md-5 col-sm-3 col-3 text-end">
                <div className="row">
                  <div className="col-lg-12">

                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="border-bottom pb-2">
            <div className={`row ${styles.chargingH5_Kratos} pr-2 pl-2`} style={{ textAlign: 'center' }}>
              <div className={`col-xl-1 col-lg-1 col-md-1 col-sm-3 col-3 ${styles.highlight_five_Kratos}`}>
                <div className="align-items-center">
                  <div className={`${styles.chargingWidgetIcon1_Kratos} text-center`}><img src="../../../assets/img_Bus/CESL_Charging/1_ChargingGun_O.svg" /> </div>
                  <div className="text-center">
                    <p className="h5 m-0">{time_convert(median_gunDurationInMin)}</p>
                    <p className={`m-0 ${styles.chargingKpiSmallTxt_Kratos}`}><small className="text-muted">Median gun duration(hh:mm:ss)</small></p>
                  </div>
                </div>
              </div>
              <div className={`col-xl-1 col-lg-1 col-md-1 col-sm-3 col-3 ${styles.highlight_five_Kratos}`}>
                <div className="align-items-center">
                  <div className={`${styles.chargingWidgetIcon1_Kratos} text-center`}><img src="../../../assets/img_Bus/CESL_Charging/ChargeDuration_F.svg" /> </div>
                  <div className="text-center">
                    <p className="h5 m-0">{time_convert(median_chargeDurationInMin)}</p>
                    <p className={`m-0 ${styles.chargingKpiSmallTxt_Kratos}`}><small className="text-muted">Median Charge duration(hh:mm:ss)</small></p>
                  </div>
                </div>
              </div>
              <div className={`col-xl-1 col-lg-1 col-md-1 col-sm-3 col-3 ${styles.highlight_five_Kratos}`}>
                <div className="align-items-center">
                  <div className={`${styles.chargingWidgetIcon1_Kratos} text-center`}><img src="../../../assets/img_Bus/CESL_Charging/GunAfterFulCharge_F.svg" /> </div>
                  <div className="text-center">
                    <p className="h5 m-0">{time_convert(median_gunAfterfullchargeInMin)}</p>
                    <p className={`m-0 ${styles.chargingKpiSmallTxt_Kratos}`}><small className="text-muted">Gun after full charge(hh:mm:ss)</small></p>
                  </div>
                </div>
              </div>
              <div className={`col-xl-1 col-lg-1 col-md-1 col-sm-3 col-3 ${styles.highlight_five_Kratos}`}>
                <div className="align-items-center">
                  <div className={`${styles.chargingWidgetIcon1_Kratos} text-center`}><img src="../../../assets/img_Bus/CESL_Charging/4_Median_ROC_O.svg" /></div>
                  <div className="text-center">
                    <p className="h5 m-0">{median_NoOfInterrupt}</p>
                    <p className={`m-0 ${styles.chargingKpiSmallTxt_Kratos}`}><small className="text-muted">Median interruption</small></p>
                  </div>
                </div>
              </div>
              <div className={`col-xl-1 col-lg-1 col-md-1 col-sm-3 col-3 ${styles.highlight_five_Kratos}`}>
                <div className="align-items-center">
                  <div className={`${styles.chargingWidgetIcon1_Kratos} text-center`}><img src="../../../assets/img_Bus/CESL_Charging/MedianTimePercentage_O.svg" /> </div>
                  <div className="text-center">
                    <p className="h5 m-0">{time_convert(median_InterruptDurationInMin)}</p>
                    <p className={`m-0 ${styles.chargingKpiSmallTxt_Kratos}`}><small className="text-muted">Interruption Time(hh:mm:ss)</small></p>
                  </div>
                </div>
              </div>
              <div className={`col-xl-1 col-lg-1 col-md-1 col-sm-3 col-3 ${styles.highlight_five_Kratos}`}>
                <div className="align-items-center">
                  <div className={`${styles.chargingWidgetIcon1_Kratos} text-center`}><img src="../../../assets/img_Bus/CESL_Charging/SOC_charging_per_cycle.svg" /> </div>
                  <div className="text-center">
                    <p className="h5 m-0">{median_delta_soc.toFixed(0)}</p>
                    <p className={`m-0 ${styles.chargingKpiSmallTxt_Kratos}`}><small className="text-muted">SOC Charged/cycle</small></p>
                  </div>
                </div>
              </div>
              <div className={`col-xl-1 col-lg-1 col-md-1 col-sm-3 col-3 ${styles.highlight_five_Kratos}`}>
                <div className="align-items-center">
                  <div className={`${styles.chargingWidgetIcon1_Kratos} text-center`}><img src="../../../assets/img_Bus/CESL_Charging/KWH_charging_per_cycle.svg" /> </div>
                  <div className="text-center">
                    <p className="h5 m-0">{median_kwhCharged.toFixed(0)}</p>
                    <p className={`m-0 ${styles.chargingKpiSmallTxt_Kratos}`}><small className="text-muted">kWh Charged/cycle</small></p>
                  </div>
                </div>
              </div>
              <div className={`col-xl-1 col-lg-1 col-md-1 col-sm-3 col-3 ${styles.highlight_five_Kratos}`}>
                <div className="align-items-center">
                  <div className={`${styles.chargingWidgetIcon1_Kratos} text-center`}><img src="../../../assets/img_Bus/CESL_Charging/ROC.svg" /> </div>
                  <div className="text-center">
                    <p className="h5 m-0">{median_roc.toFixed(2)}</p>
                    <p className={`m-0 ${styles.chargingKpiSmallTxt_Kratos}`}><small className="text-muted">ROC</small></p>
                  </div>
                </div>
              </div>
              <div className={`col-xl-1 col-lg-1 col-md-1 col-sm-3 col-3 ${styles.highlight_five_Kratos}`}>
                <div className="align-items-center">
                  <div className={`${styles.chargingWidgetIcon1_Kratos} text-center`}><img src="../../../assets/img_Bus/CESL_Charging/charging_current.svg" /> </div>
                  <div className="text-center">
                    <p className="h5 m-0">{median_avgChargingCurrent.toFixed(2)}</p>
                    <p className={`m-0 ${styles.chargingKpiSmallTxt_Kratos}`}><small className="text-muted">Charging Current</small></p>
                  </div>
                </div>
              </div>
            </div>
          </div>{/* KPI Section Row Ends */}
          <div className={`row ${styles.chargingH5_Kratos} p-1`}>
            <div className={`col-xl-1 col-lg-1 col-md-1 col-sm-3 col-3 ${styles.highlight_five_Kratos}`}>
              <div className="align-items-center">
                <div className={`${styles.chargingWidgetIcon1_Kratos} text-center`}><img src="../../../assets/img_Bus/CESL_Charging/SOC_Charging_Start.svg" /> </div>
                <div className="text-center">
                  <p className="h5 m-0">{median_soc_start.toFixed(0)}</p>
                  <p className={`m-0 ${styles.chargingKpiSmallTxt_Kratos}`}><small className="text-muted">SOC @ Charging Start</small></p>
                </div>
              </div>
            </div>
            <div className={`col-xl-1 col-lg-1 col-md-1 col-sm-3 col-3 ${styles.highlight_five_Kratos}`}>
              <div className="align-items-center">
                <div className={`${styles.chargingWidgetIcon1_Kratos} text-center`}><img src="../../../assets/img_Bus/CESL_Charging/SOC_Charging_End.svg" /> </div>
                <div className="text-center">
                  <p className="h5 m-0">{median_soc_end.toFixed(0)}</p>
                  <p className={`m-0 ${styles.chargingKpiSmallTxt_Kratos}`}><small className="text-muted">SOC @ Charging End</small></p>
                </div>
              </div>
            </div>
            <div className={`col-xl-1 col-lg-1 col-md-1 col-sm-3 col-3  ${styles.highlight_five_Kratos}`}>
              <div className="align-items-center">
                <div className={`${styles.chargingWidgetIcon1_Kratos} text-center`}><img src="../../../assets/img_Bus/CESL_Charging/Max_temp.svg" /> </div>
                <div className="text-center">
                  <p className="h5 m-0">{median_A_Max_Cell_Temp}</p>
                  <p className={`m-0 ${styles.chargingKpiSmallTxt_Kratos}`}><small className="text-muted">Max Temp</small></p>
                </div>
              </div>
            </div>
            {/* <div className={`col-xl-1 col-lg-1 col-md-1 col-sm-3 col-3  ${styles.highlight_five_Kratos}`}>
              <div className="align-items-center">
                <div className={`${styles.chargingWidgetIcon1_Kratos} text-center`}><img src="../../../assets/img_Bus/CESL_Charging/Max_temp_B.svg" /> </div>
                <div className="text-center">
                  <p className="h5 m-0">{median_B_Max_Cell_Temp.toFixed(0)}</p>
                  <p className={`m-0 ${styles.chargingKpiSmallTxt_Kratos}`}><small className="text-muted">Max Temp - Pack B</small></p>
                </div>
              </div>
            </div>
            <div className={`col-xl-1 col-lg-1 col-md-1 col-sm-3 col-3 ${styles.highlight_five_Kratos}`}>
              <div className="align-items-center">
                <div className={`${styles.chargingWidgetIcon1_Kratos} text-center`}><img src="../../../assets/img_Bus/CESL_Charging/Max_temp_C.svg" /> </div>
                <div className="text-center">
                  <p className="h5 m-0">{median_C_Max_Cell_Temp.toFixed(0)}</p>
                  <p className={`m-0 ${styles.chargingKpiSmallTxt_Kratos}`}><small className="text-muted">Max Temp - Pack C</small></p>
                </div>
              </div>
            </div>
            <div className={`col-xl-1 col-lg-1 col-md-1 col-sm-3 col-3 ${styles.highlight_five_Kratos}`}>
              <div className="align-items-center">
                <div className={`${styles.chargingWidgetIcon1_Kratos} text-center`}><img src="../../../assets/img_Bus/CESL_Charging/Max_temp_D.svg" /> </div>
                <div className="text-center">
                  <p className="h5 m-0">{median_D_Max_Cell_Temp.toFixed(0)}</p>
                  <p className={`m-0 ${styles.chargingKpiSmallTxt_Kratos}`}><small className="text-muted">Max Temp - Pack D</small></p>
                </div>
              </div>
            </div> */}
            <div className={`col-xl-1 col-lg-1 col-md-1 col-sm-3 col-3 ${styles.highlight_five_Kratos}`}>
              <div className="align-items-center">
                <div className={`${styles.chargingWidgetIcon1_Kratos} text-center`}><img src="../../../assets/img_Bus/CESL_Charging/daily_charging_cycles_per_vehicle.svg" /> </div>
                <div className="text-center">
                  <p className="h5 m-0">{doc_cnt}</p>
                  <p className={`m-0 ${styles.chargingKpiSmallTxt_Kratos}`}><small className="text-muted">Daily Charging Cycles/vehicle</small></p>
                </div>
              </div>
            </div>
            <div className={`col-xl-1 col-lg-1 col-md-1 col-sm-3 col-3 ${styles.highlight_five_Kratos}`}>
              <div className="align-items-center">
                <div className={`${styles.chargingWidgetIcon1_Kratos} text-center`}><img src="../../../assets/img_Bus/CESL_Charging/daily_charging_KWH_per_vehicle.svg" /> </div>
                <div className="text-center">
                  <p className="h5 m-0">{Daily_Charging_Duration_vehicle}</p>
                  <p className={`m-0 ${styles.chargingKpiSmallTxt_Kratos}`}><small className="text-muted">Daily Charging kWh/vehicle</small></p>
                </div>
              </div>
            </div>
            <div className={`col-xl-1 col-lg-1 col-md-1 col-sm-3 col-3 ${styles.highlight_five_Kratos}`}>
              <div className="align-items-center">
                <div className={`${styles.chargingWidgetIcon1_Kratos} text-center`}><img src="../../../assets/img_Bus/CESL_Charging/daily_charging_duration_per_vehicle.svg" /> </div>
                <div className="text-center">
                  <p className="h5 m-0">{time_convert(Daily_Charging_kWh_vehicle)}</p>
                  <p className={`m-0 ${styles.chargingKpiSmallTxt_Kratos}`}><small className="text-muted">Daily Charging Dur/vin(hh:mm:ss)</small></p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* KPI section ends */}
      </div>
    </>
  )
}